export default __webpack_public_path__ + "images/88a2ff4848075fd3bc516fa77cb1e8aa.png";